// src/services/authService.js
const API_URL = "https://yesedacademy.com/database";
const API_SECRET = process.env.REACT_APP_API_SECRET; // set in .env.local

export async function loginUser(username, password) {
  try {
    const response = await fetch(`${API_URL}/auth.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": API_SECRET,
        
      },
      
      body: JSON.stringify({ username, password })
    });
//console.log("API key:", process.env.REACT_APP_API_SECRET);
    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Login API error:", err);
    throw err;
  }
}

export async function updateMobile(username, password, mobile) {
  try {
    const response = await fetch(`${API_URL}/mobile.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": API_SECRET
      },
      body: JSON.stringify({ username, password, mobile })
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Update Mobile API error:", err);
    throw err;
  }
}

export async function resetPassword(upUsername) {
  try {
    const response = await fetch(`${API_URL}/updatePassword.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-API-KEY": API_SECRET
      },
      body: JSON.stringify({ upUsername })
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Reset Password API error:", err);
    throw err;
  }
}
